<template>
    <UModal v-model="isOpen">
        <UCommandPalette
            v-model="selected"
            multiple
            nullable
            :groups="[]"
        />
    </UModal>
</template>

<script setup lang="ts">
const emit = defineEmits<{
    'update:open': [boolean]
}>()

const props = defineProps<{
    open: boolean
}>()

const isOpen = computed({
    get: () => props.open,
    set: (open) => emit('update:open', open),
})

const selected = ref()
</script>